import React from 'react'
import "./learnToShare.scss"

import SectionComponent from '../../../../components/utils/SectionComponent'
import { useTranslation } from 'react-i18next'

function LearnToShare() {

  const {t} =  useTranslation()

  return (
    <div className='container-learn-to-share'>
      <div className="texts-learn-to-share">
        <SectionComponent  title={t("publish_and_share.learn_to_share.title")} text={t("publish_and_share.learn_to_share.section_text")} />
      </div>
    </div>
  )
}

export default LearnToShare